import React from 'react';
import { style } from 'typestyle';

import { FieldArrayRenderProps, FormikContextType } from '~src/settings/FormikWrapperForStubbing';
import { IRemoteQueryAgent } from '~src/settings/types/ISiteAdminBridgeSettings';
import { FeatureFlags } from '~src/ts/FeatureFlags';
import { L10n } from '~src/ts/L10n/L10n';
import { IRemoteAgentConnectionStatus } from '~src/ts/ServerApi/requests/GetSiteRemoteAgentsConnectionStatusRequest';

import { SiteBridgeSettingsForSiteAdminProps } from '../../../bridge-settings/BridgeSiteSettings';
import { PoolAssignmentOption } from '../types/PoolAssignmentOption';
import { PoolID } from '../types/PoolID';
import { BridgeRemoteAgentsDeleteButton } from './BridgeRemoteAgentsDeleteButton';
import { BridgeRemoteAgentsEditButton } from './BridgeRemoteAgentsEditButton';
import { BridgeRemoteAgentsPoolCell } from './BridgeRemoteAgentsPoolCell';
import { BridgeRemoteAgentsPresenceIcon } from './BridgeRemoteAgentsPresenceIcon';
import { BridgeRemoteAgentsUpdateTooltip } from './BridgeRemoteAgentsUpdateTooltip';

export type BridgeRemoteAgentsTableRowProps = Readonly<{
  agent: IRemoteQueryAgent;
  index: number;
  connectionStatuses: IRemoteAgentConnectionStatus[];
  arrayHelpers: FieldArrayRenderProps;
  poolTestId: string;
  isDefaultPool: boolean;
  formik: FormikContextType<SiteBridgeSettingsForSiteAdminProps>;
  poolOptions: ReadonlyArray<PoolAssignmentOption>;
  siteId: string;
  agentPoolId: PoolID;
  refreshEdgePools: () => void;
}>;

export function BridgeRemoteAgentsTableRow(props: BridgeRemoteAgentsTableRowProps) {
  const { agent, index, connectionStatuses, arrayHelpers, poolTestId, isDefaultPool } = props;
  const cellClass = tableCellMaxWidth + (FeatureFlags.edgeMultiPoolEnabled ? ' tb-data-grid-separator-row' : '');

  return <>
    <td className={cellClass}>
      <span className={'tb-data-grid-cell-text tb-lr-padded-wide'} data-tb-test-id={'agent-name-cell' + poolTestId}>
        {agent.agentName}
      </span>
    </td>
    <td className={cellClass}>
      <span className={'tb-data-grid-cell-text tb-lr-padded-wide'} data-tb-test-id={'agent-owner-name-cell' + poolTestId}>
        {agent.ownerFriendlyName}
      </span>
    </td>
    {BridgeRemoteAgentsPoolCell(agent, index, arrayHelpers, isDefaultPool)}
    <td className={cellClass}>
      <span className={'tb-data-grid-cell-text tb-lr-padded-wide'} data-tb-test-id={'agent-version-cell' + poolTestId}>
        {BridgeRemoteAgentsUpdateTooltip(agent)}
        {agent.version}
      </span>
    </td>
    <td className={cellClass}>
      {BridgeRemoteAgentsPresenceIcon(agent, connectionStatuses, poolTestId)}
    </td>
    <td className={cellClass}>
      <span className={'tb-data-grid-cell-text tb-lr-padded-wide'} data-tb-test-id={'agent-last-used-cell' + poolTestId}>
        {L10n.localizedDateTimeForISO8601FormattedString(agent.lastUsed)}
      </span>
    </td>
    <td className={cellClass}>
      {BridgeRemoteAgentsEditButton(props)}
      {BridgeRemoteAgentsDeleteButton(props)}
    </td>
  </>;
}

const tableCellMaxWidth = style({
  maxWidth: 200,
  overflow: 'hidden'
});
